import { backend } from '~/services';
import { toFile } from '~/utils/documents';

import { apiPaths } from './routes';

export function getCompanies() {
  return backend.get(apiPaths.company);
}

export function getDeletedCompanies() {
  return backend.get(`${apiPaths.company}/deleted`);
}

export function createCompany(data) {
  return backend.post(apiPaths.company, data);
}

export function createCompanies(data) {
  return backend.post(`${apiPaths.company}/bulk`, data);
}

export function getCompany(id) {
  return backend.get(`${apiPaths.company}/${id}`);
}

export function getCompanyTemplate() {
  return backend.get(`${apiPaths.company}/template`, { responseType: 'blob' });
}

export function updateCompany({ id, data }) {
  return backend.put(`${apiPaths.company}/${id}`, data);
}

export function deleteCompany(id, force = false) {
  return backend.delete(`${apiPaths.company}/${id}?force=${force}`);
}

export function restoreCompany(id) {
  return backend.patch(`${apiPaths.company}/${id}`);
}

export function updateImplicitSupport(data) {
  return backend.post(`${apiPaths.company}/implicit-support`, data);
}

export function updateImplicitRating(data) {
  return backend.post(`${apiPaths.company}/adjust-rating`, data);
}

export function updateImplicitProbabilityOfDefault(data, cancelToken) {
  return backend.post(`${apiPaths.company}/adjust-pod`, data, { cancelToken });
}

export function getCompanyAuditTrails(companyId) {
  return backend.get(`${apiPaths.company}/${companyId}/audit`);
}

export function getCompanyAuditTrail({ companyId, auditId }) {
  return backend.get(`${apiPaths.company}/${companyId}/audit/${auditId}`);
}

export function deleteCompanyAuditTrail({ companyId, auditId }) {
  return backend.delete(`${apiPaths.company}/${companyId}/audit/${auditId}`);
}

export async function exportCompaniesAsExcel() {
  const response = await backend.post(`${apiPaths.company}/export`, null, { responseType: 'blob', fullResponse: true });
  return toFile(response);
}
